<app-control-wrapper [control]="fc" [errors]="errors" [helper]="helper" [isShowHelper]="isShowHelper">
  <label control-label [for]="id">{{ label | translate }}</label>
  <input
    control-wrapper
    [type]="isShowPassword ? 'text' : 'password'"
    [formControl]="fc"
    class="form-control"
    [id]="id"
    [name]="id"
    [dropSpecialCharacters]="false"
    [patterns]="CUSTOM_MASK"
    [mask]="'F*'"
    [maxlength]="maxLength"
    [appMaskErrorTooltip]="'MASK_ERROR.ONLY_ENGLISH_DIGITS_AND_SPECIAL'"
  />
  <button type="button" control-wrapper class="button-eye" [disabled]="isShowPassword" (click)="showPassword()">
    <i class="fa fa-eye" aria-hidden="true"></i>
  </button>
</app-control-wrapper>
